import script from "./ManageOrganisation.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageOrganisation.vue?vue&type=script&setup=true&lang=js"

import "./ManageOrganisation.vue?vue&type=style&index=0&id=7deee159&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2025-january\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7deee159"]])

export default __exports__